var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',{attrs:{"variant":_vm.variant,"label":_vm.saleStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }